<template>
  <div class="top1">
    <div class="left" @click="centerDialogVisible = true">
      <img :src="leftImg" alt="" class="img">
      <img src="../../assets/img/home/bofang.png" alt="" class="bofang">
    </div>
    <div class="right">
      <div class="top">
        <el-tabs v-model="activeName">
          <el-tab-pane name="1">
            <span slot="label">关于本项目</span>
            <div class="main">
              <div class="title">{{ title }}</div>
              <div class="content">{{ abstract }}</div>
              <!-- <div class="more">查看详情 ></div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane name="2" v-if="tmeplist">
            <span slot="label">案例模版下载</span>
            <div class="download" v-for="(item, index) in tmeplist" :key="'tmp' + index">
              <div class="doc" @click="download(item.fileUrl, (item.fileName + getFileex(item.fileUrl)))">
                <div class="txt">
                  <img
                    :src="item.type == 2 ? require('../../assets/img/icon/ppt.png') : require('../../assets/img/icon/word.png')"
                    style="width: 27px; margin-right: 10px;" alt="">
                  <span>{{ item.fileName }} {{ getFileex(item.fileUrl) }}</span>
                </div>
                <div class="btn">下载</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label">我的状态</span>
            <div class="status">
              <div class="item">
                <div class="iTitle">案例上传</div>
                <div class="jidu">
                  <div class="child" v-for="(item, index) in statusList" :key="index">
                    <div class="line" :class="{ lineActive: activeStatus > index }"></div>
                    <div class="quan" :class="{ quanActive: activeStatus > index }"></div>
                    <div class="text" :class="{ textActive: activeStatus > index }">{{ item }}</div>
                  </div>
                </div>
                <div class="btn" @click="toUser">{{ activeStatus == 0 ? '去上传' : (activeStatus == 1 ? '待审核' :
                  activeStatus == 3 ? '已入库' : activeStatus == 2 ? '未通过' : '已完成') }}</div>
              </div>
              <div class="item">
                <div class="iTitle">课程学习</div>
                <div class="center">
                  <div class="progress">
                    <el-progress type="circle" :percentage="percentage" :show-text="false" :width="44" :stroke-width="4"
                      color="#F36633" define-back-color="#BEC6D2"></el-progress>
                  </div>
                  <div class="txt">已学习 {{ num }}/{{ total }}</div>
                  <div class="btn">去学习</div>
                </div>
              </div>
              <div class="item">
                <div class="iTitle">案例学习</div>
                <div class="center">
                  <div class="progress">
                    <img src="../../assets/img/home/wenjian.png" alt="">
                  </div>
                  <div class="txt" style="margin-top: 5px;">案例学习</div>
                  <!-- <div class="txt" style="margin:0">敬请期待</div> -->

                  <div class="btn" @click="goto()">去学习</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog :title="videotitle" :visible.sync="centerDialogVisible" width="50%" center>
      <video v-if="centerDialogVisible" :src="src" controls style="width: 100%" ref="video"></video>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

export default {
  data () {
    return {
      activeName: '1',
      statusList: ['未上传', '审核中', '入库', '精修'],
      activeStatus: 0,
      total: 0,
      num: 0,
      percentage: 0,
      wordurl: '',
      ppturl: '',
      title: '',
      abstract: '',
      leftImg: '',
      centerDialogVisible: false,
      src: '',
      videotitle: '',
      tmeplist: []
    }
  },

  created () {
    this.getNumber()
    this.isUpload()
    this.getfile()
    this.getZx()
    this.getSp()
  },

  methods: {
    goto () {
      this.$router.push('/refinedSift')
    },
    getNumber () {
      let params = {
        userId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userId : 0
      }
      this.httphelper.get('WebSiteApi/GetCourselearning', params).then(res => {
        if (res.code == 200) {
          this.total = res.data.corCount
          this.num = res.data.learnedNum
          this.percentage = res.data.learnedNum / res.data.corCount * 100
        }
      })
    },

    isUpload () {
      let params = {
        UserId: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userId : 0
      }
      this.httphelper.get('/ActicleApi/GetUserActicletype', params).then(res => {
        if (res.code == 200) {
          this.activeStatus = res.data.acticle_type
        }
      })
    },

    toUser () {
      if (this.activeStatus == 0) {
        this.$router.push('/user/upload')
      } else {
        this.$router.push('/user/myCase')
      }
    },
    // 获取文件名称
    getFileex (url) {
      return url.substring(url.lastIndexOf('.'))
    },
    getfile () {
      let params = {
        type: 1
      }
      this.httphelper.get('/WebSiteApi/GetHCCaseTemplateList', params).then(res => {
        if (res.code == 200) {
          let arr = res.data
          this.tmeplist = arr
        }
      })
    },

    getZx () {
      this.httphelper.post('/WebSiteApi/GetHCNewInfoAllList', {
        c_Id: 2,
        page: 1,
        limit: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.title = res.data.data[0].title
          this.abstract = res.data.data[0].abstract
        }
      })
    },

    getSp () {
      this.httphelper.post('/WebSiteApi/GetHCNewInfoAllList', {
        c_Id: 1,
        page: 1,
        limit: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.leftImg = res.data.data[0].slideShow
          this.videotitle = res.data.data[0].title
          this.src = res.data.data[0].videoUrl
        }
      })
    },

    open (url) {
      window.open(url)
    },
    download (url, fileName) {
      // 在请求接口前创建loading参数
      const options = {
        text: '下载中...',
        background: 'rgba(255,255,255,0.6)',
        spinner: 'el-icon-loading',
        lock: true,
        // target指定需要覆盖的 DOM 节点
        target: '#app'
      };
      let loadingInstance = Loading.service(options);
      const link = document.createElement('a');
      // 这里是将链接地址url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => {
        link.href = URL.createObjectURL(blob)
        // 下载文件的名称及文件类型后缀
        link.download = fileName;
        document.body.appendChild(link)
        link.click()
        // 在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
        loadingInstance.close()
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.top1 {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0px 60px 0px;
  display: flex;

  .left {
    width: 500px;
    height: 288px;
    position: relative;
    cursor: pointer;

    .img {
      width: 100%;
      height: 100%;
      border-radius: 15px;
    }

    .bofang {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 220px;
      top: 114px;
    }
  }

  .right {
    width: 630px;
    height: 288px;
    margin-left: 70px;

    .main {
      .title {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 18px;
        color: #000000;
      }

      .content {
        width: 100%;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 28px;
        margin-top: 20px;
        height: 175px;
        overflow: auto;
      }

      .more {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #404040;
        margin-top: 80px;
      }
    }

    .download {

      .doc,
      .pptx {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .txt {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 16px;
          color: #000;
          line-height: 50px;
          display: flex;
          align-items: center;
        }

        .btn {
          width: 90px;
          height: 30px;
          background: #fff8f5;
          border-radius: 15px;
          border: 1px solid #f36633;
          text-align: center;
          line-height: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #f36633;
        }
      }

      .doc:hover {
        .txt {
          color: #f36633;
          text-decoration-line: underline;
        }

        .btn {
          border: none;
          background: #f36633;
          color: #fff;
        }
      }

      .pptx:hover {
        .txt {
          color: #f36633;
          text-decoration-line: underline;
        }

        .btn {
          border: none;
          background: #f36633;
          color: #fff;
        }
      }
    }

    .status {
      display: flex;
      justify-content: space-between;

      .item {
        width: 201px;
        height: 226px;
        background: #f7f7f7;
        border-radius: 6px;

        .iTitle {
          text-align: center;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 18px;
          color: #000000;
          margin-top: 31px;
        }

        .jidu {
          display: flex;
          justify-content: center;
          margin-top: 40px;

          .child {
            position: relative;

            .line {
              width: 45px;
              height: 3px;
              background: #bec6d2;
              border-radius: 2px;
            }

            .quan {
              width: 10px;
              height: 10px;
              background: #f7f7f7;
              border-radius: 50%;
              border: 2px solid #bec6d2;
              position: absolute;
              left: 15px;
              top: -6px;
            }

            .text {
              text-align: center;
              font-family: Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              color: #000;
              margin-top: 5px;
            }

            .lineActive {
              background: #f36633;
            }

            .quanActive {
              border: 2px solid #f36633;
            }

            .textActive {
              color: #f36633;
            }
          }
        }

        .center {
          .progress {
            display: flex;
            justify-content: center;
            margin-top: 12px;
          }

          .txt {
            text-align: center;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            margin-top: 13px;
          }

          .btn {
            width: 100px;
            height: 36px;
            background: #ffffff;
            box-shadow: 5px 9px 15px 0px rgba(0, 0, 0, 0.04);
            border-radius: 18px;
            border: 1px solid #efefef;
            margin: 0 auto;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            text-align: center;
            line-height: 36px;
            margin-top: 24px;
            cursor: pointer;
          }

          .btn:hover {
            background: #f36633;
            color: #fff;
          }
        }

        .btn {
          width: 100px;
          height: 36px;
          background: #ffffff;
          box-shadow: 5px 9px 15px 0px rgba(0, 0, 0, 0.04);
          border-radius: 18px;
          border: 1px solid #efefef;
          margin: 0 auto;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          text-align: center;
          line-height: 36px;
          margin-top: 40px;
          cursor: pointer;
        }

        .btn:hover {
          background: #f36633;
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-tabs__nav {
  padding-bottom: 10px;
}

::v-deep .is-active {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #f36633 !important;
}

::v-deep .el-tabs__active-bar {
  background: #f36633 !important;
}

::v-deep .el-tabs__item:hover {
  color: #f36633 !important;
}

::v-deep .el-tabs__item {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #000;
}
</style>
